<template>
  <div class="judgetrue">
    <h1>查询结果</h1>
    <div class="tip">尊敬的顾客：您查询的是{{company}}烟厂生产的{{product}},为正品。</div>
    <div class="pic-warpper">
      <img src="../../assets/images/yan.png" alt />
    </div>
    <p>咨询电话：400654654XX</p>
    <div class="footer">
      <span class="btn" @click="search">再次验证</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      company: "XX",
      product: "XX",
      webpath: "http://ksy7.cn/wxapi/getWxSign"
    }
  },
  methods: {
    search: function () {
      this.initTocken();
    },
    initTocken: function () {
      var that = this;
      var sign = "";
      $.ajax({
        debug: true,
        type: "get",
        url: that.webpath,
        async: false,
        cache: false,
        timeout: 60000,
        scriptCharset: "utf-8",
        data: { url: location.href.split('#')[0] },
        success: function (sign) {
          console.log(sign)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: sign.appId, // 必填，公众号的唯一标识
            timestamp: sign.timestamp, // 必填，生成签名的时间戳
            nonceStr: sign.nonceStr, // 必填，生成签名的随机串
            signature: sign.signature,// 必填，签名，见附录1
            jsApiList: ['getLocation', 'chooseImage', 'uploadImage', 'previewImage', 'downloadImage', 'scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
            console.log('wxsuccess');
            wx.scanQRCode({
              needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                //   console.log(res);
                // var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                // console.log(result);
                // var code = result.substring(result.lastIndexOf("/") + 1);
                // console.log(code);
                // this.$router.push({ path: '/result', query: { id: code } });
              }
            });
          });
          wx.error(function (res) {
            console.error(res)
          });
        },
        error: function (err) {

        }
      });

    }
  }
}
</script>

<style  lang="stylus" scoped>
.judgetrue {
  box-sizing: border-box;
  padding: 0.555556rem;

  h1 {
    line-height: 1.333333rem;
    font-size: 0.666667rem;
    color: #009fe8;
    text-align: center;
    margin-top: 1.111111rem;
  }

  .tip {
    width: 7.083333rem;
    margin: 0 auto;
    line-height: 0.555556rem;
    font-size: 0.444444rem;
    margin-top: 35px;
  }

  .pic-warpper {
    width :5.555556rem;
    margin: 1.111111rem auto;

    img {
      width: 100%;
    }
  }

  p {
    text-align: center;
    font-size: 0.472222rem;
    line-height: 0.777778rem;
  }

  .footer {
    text-align: center;
    position: fixed;
    bottom: 0.833333rem;
    left: 0;
    width: 100%;

    .btn {
      font-size: 0.5rem;
      color: #009fe8;
      border-bottom: 1px solid #009fe8;
      padding: 3px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/example01/judgetrue.vue